import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

export const MonthlySuggestModal = ({ open, days, onMoveToMonthly, onContinue }) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onContinue()}>
      <DialogContent data-testid="monthly-suggest-modal">
        <DialogHeader>
          <DialogTitle className="heading-upper text-[#144733]">{t("A better rate for {{days}} days", { days })}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-[#57685e]">
          {t("Rentals of 22 days or more qualify as a monthly rental — and our Monthly Rentals page has the best offers for your dates. Your dates and location carry over automatically.")}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 mt-2">
          <button onClick={onMoveToMonthly} className="btn-cta rounded flex-1 py-3 text-xs" data-testid="move-to-monthly-btn">
            {t("Move to Monthly booking")}
          </button>
          <button onClick={onContinue}
            className="flex-1 border-2 border-[#144733] text-[#144733] rounded py-3 text-xs font-medium uppercase tracking-wide hover:bg-[#f0f5f0]"
            data-testid="continue-daily-btn">
            {t("Continue with daily rate")}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
